import "./RatingDistribution.css";

function RatingDistribution({ reviews }) {
  const totalReviews = reviews.length;

  const getCount = (rating) =>
    reviews.filter((item) => item.rating === rating).length;

  const ratings = [5, 4, 3, 2, 1];

  return (
    <div className="rating-distribution">

      <div className="distribution-header">
        <h2>Rating Distribution</h2>
        <span>{totalReviews} Reviews</span>
      </div>

      {ratings.map((rating) => {
        const count = getCount(rating);

        const percentage =
          totalReviews > 0
            ? (count / totalReviews) * 100
            : 0;

        return (
          <div
            key={rating}
            className="distribution-row"
          >
            <div className="rating-label">
              {rating} ★
            </div>

            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{
                  width: `${percentage}%`,
                }}
              />
            </div>

            <div className="rating-count">
              {count}
            </div>
          </div>
        );
      })}

    </div>
  );
}

export default RatingDistribution;